import * as React from "react";
import { Query, graphql } from "react-apollo";
import { Row, Col, Button } from "reactstrap";
import * as uuid from "uuid";
import { MdModeEdit, MdDeleteForever } from "react-icons/md";

// GraphQL
import GetCompanyUsers from "../../GraphQL/Queries/GetCompanyUsers";
import DisableUser from "../../GraphQL/Mutations/DisableUser";

// Presentation/UI
import Loader from "../../Components/Loader/DotLoader";
import Table from "../../Components/Table";
import GlobalModal from "../../Components/GlobalModal";
import DialogModal from "../../Components/DialogModal";

import EditUserForm from "./EditUserForm";

interface IProps {
  companyId: string;
  loggedInUser: string;
  toastManager: any;
  mutate: any;
}

class AllUsers extends React.Component<IProps> {
  state = {
    modal: false,
    dialogModal: false,
    loading: false,
    title: "Are you sure you want to disable this user?",
    user: {},
    userId: null
  };

  // Close dialog modal
  closeDialogModal = (): void => {
    this.setState({
      dialogModal: false
    });
  };

  // Open dialog modal
  openDialogModal = (companyUser: any): void => {
    const userId = !companyUser ? null : companyUser.id;
    this.setState({
      dialogModal: true,
      userId
    });
  };

  // Handle response
  handleResponse = (e: React.FormEvent<HTMLInputElement>): void => {
    e.preventDefault();
    this.setState({ loading: true });
    // disable user mutation
    const { companyId } = this.props;
    this.props
      .mutate({
        variables: {
          id: this.state.userId,
          disabled: true
        },
        refetchQueries: [
          {
            query: GetCompanyUsers,
            variables: { id: companyId }
          }
        ]
      })
      .then((res: any) => {
        this.setState({ loading: false, userId: null });
        this.closeDialogModal();
        this.toastNotification("User disabled successfully");
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  // Close modal
  closeModal = (): void => {
    this.setState({
      modal: false
    });
  };

  // Open modal
  openModal = (user: object): void => {
    this.setState({
      modal: true,
      user
    });
  };

  // success notification
  toastNotification = (message: string) => {
    this.props.toastManager.add(message, {
      appearance: "success",
      autoDismiss: true
    });
  };

  render() {
    const { user } = this.state;
    const { companyId } = this.props;
    return (
      <Query query={GetCompanyUsers} variables={{ id: companyId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the users</div>;
          }

          /* let users = data.allUsers;
          users =
            !users || !users.length
              ? []
              : users.filter((teamUser: any) => teamUser.id !== loggedInUser); */

          const users = data.allUsers;

          return (
            <Row>
              <GlobalModal
                toggleModal={this.closeModal}
                title="Edit User"
                modalDisplay={
                  <EditUserForm
                    notification={this.toastNotification}
                    closeModal={this.closeModal}
                    companyId={companyId}
                    user={user}
                  />
                }
                modal={this.state.modal}
              />
              <DialogModal
                modal={this.state.dialogModal}
                title={this.state.title}
                loading={this.state.loading}
                toggleModal={this.closeDialogModal}
                handleResponse={this.handleResponse}
              />
              <Col xs={12} md={12} lg={12}>
                <Table
                  data={users}
                  columns={[
                    {
                      Header: "First Name",
                      accessor: "firstName",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Last Name",
                      accessor: "lastName",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Email",
                      accessor: "email",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Job Title",
                      accessor: "jobTitle",
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "Email Verified",
                      accessor: (companyUser: any) => {
                        return companyUser.emailVerified ? "Yes" : "No";
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Phone Number",
                      accessor: "phoneNumber",
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "",
                      accessor: (companyUser: object) => {
                        return (
                          <Button
                            onClick={() => this.openModal(companyUser)}
                            className="icon-btn icon-edit-btn"
                          >
                            <MdModeEdit color="#fff" size="1.35em" />
                          </Button>
                        );
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "",
                      accessor: (companyUser: object) => {
                        return (
                          <Button
                            onClick={() => this.openDialogModal(companyUser)}
                            className="icon-btn icon-delete-btn"
                          >
                            <MdDeleteForever color="#fff" size="1.35em" />
                          </Button>
                        );
                      },
                      sortable: false,
                      filterable: false
                    }
                  ]}
                  defaultPageSize={5}
                  showPaginationTop={false}
                  showPaginationBottom={true}
                />
              </Col>
            </Row>
          );
        }}
      </Query>
    );
  }
}

export default graphql<any, Response, any, any>(DisableUser)(AllUsers);



// WEBPACK FOOTER //
// ./src/Containers/Users/AllUsers.tsx